import React from 'react';
import type { DatovkaApiType } from '@gov-nx/api';
import { useDataBoxSearchAutocomplete } from '@gov-nx/core/hooks';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { dataBoxLabel } from '@gov-nx/module/data-box';
import type { FormAutocompleteProps } from '../FormAutocomplete';
import { FormAutocomplete } from '../FormAutocomplete';

interface DataBoxSearchAutocompleteProps extends Omit<
	FormAutocompleteProps<DatovkaApiType>,
	'field'
> {
	field: Omit<
		FormAutocompleteProps<DatovkaApiType>['field'],
		'templateResolver' | 'keyResolver' | 'valueResolver' | 'searchCallback'
	>;
	dataBoxType?: DatovkaApiType['typSchranky'];
}

export const DataBoxSearchAutocomplete = (
	props: DataBoxSearchAutocompleteProps
) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);
	const { searchCallback } = useDataBoxSearchAutocomplete(
		'GENERAL',
		props.dataBoxType
	);

	return (
		<FormAutocomplete<DatovkaApiType>
			label={props.label}
			field={{
				...props.field,
				messageEmpty:
					props.field.messageEmpty ?? t('naseptavac.pole.zadny-vysledek'),
				templateResolver: (item) => dataBoxLabel(item),
				keyResolver: (item) => item.datovaSchrankaId ?? '',
				valueResolver: (item) => dataBoxLabel(item),
				searchCallback,
			}}
		/>
	);
};
